import { ReactNode } from 'react'
import { Box, Grid } from '@mui/material'
import CustomText from '../CustomText/CustomText'
import { colors } from 'styles/colors'
import useStyles from './styles'
import BreadCrumb from '../BreadCrumb/BreadCrumb'

interface Props {
	title?: string;
	description?: string;
	buttons?: ReactNode[];
	height?: number;
	showPath?: boolean;
}

export default function PageHeader({
	title,
	description,
	buttons = [],
	height = 50,
	showPath = false,
}: Props) {
	const styles = useStyles()

	return (
		<Grid
			container
			className={styles.container}
			spacing={2}
			alignItems={{ xs: 'flex-start', md: 'center' }}
			justifyContent="space-between"
			height={height}
		>
			{/* Left: Text */}

			<Grid>
				<Box>
					{title && <CustomText
						text={title}
						color={colors.primary}
						fontSize={22}
						fontWeight={700}
					/>}

					{showPath ? (
						<Box>
							<BreadCrumb />
						</Box>
					) : description ? (
						<CustomText
							text={description}
							color={colors.secondary}
							fontSize={14}
						/>
					) : null}
				</Box>
			</Grid>


			{/* Right: Buttons */}
			<Grid
				display="flex"
				gap={1}
				flexWrap="wrap"
			>
				{buttons.map((item) => (item))}
			</Grid>
		</Grid>
	)
}
